import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "master-site-edit",
  components: {
    AppHeader
  },
  created() {
    this.getSite();
  },
  data() {
    return {
      isGetSiteEnd: false,
      siteId: this.$route.params.site_id,
      site: [],
      errorInfo: null
    };
  },
  methods: {
    async getSite() {
      this.isGetSiteEnd = false;
      let data = {
        site_id: this.siteId
      };
      let res = await this.$store
        .dispatch("GET_SITE_DETAIL", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.site = res.site;
      this.isGetSiteEnd = true;
    },
    async saveSite() {
      let data = {
        site_id: this.siteId,
        is_construction_done: this.site.is_construction_done,
        site_link: this.site.site_link
      };
      let res = await this.$store
        .dispatch("SAVE_SITE", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.$router.push({ path: "/master_site" });
      }
    },
    async deleteSite() {
      let data = {
        site_id: this.siteId
      };
      let res = await this.$store
        .dispatch("DELETE_SITE", {
          id: this.$route.params.site_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
        this.$bvModal.hide("modal-delete");
        this.$bvModal.show("modal-error");
      } else {
        this.$router.push({ path: "/master_site" });
      }
    },
    dateFormat(date) {
      if (!date) {
        return "";
      }
      return dayjs(date).format("YYYY年MM月DD日");
    },
    goMasterSiteDetail() {
      this.$router.push({ path: "/master_site/" + this.siteId + "/detail" });
    }
  }
};
